export default __webpack_public_path__ + "static/media/ms_events_opt.04e1c649.jpg";